import { render } from "./first-class.vue?vue&type=template&id=37eaf1a7"
import script from "./first-class.vue?vue&type=script&lang=js"
export * from "./first-class.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__